export const AuthMessages = {
    login: {
        'AUTH-NO-SIGIN': 'Usuario o contraseña incorrecta',
        'AUTH-INACTIVE': 'Usuario inactivo',
        'AUTH-NO-CAPTCHA': 'ReCAPTCHA incorrecto',
    },
    logout: {
        TITLE_LOGOUT: 'Cerrar Sesión',
        MESSAGE_LOGOUT: 'Está seguro que desea cerrar sesión',
    },
    expirationToken: {
        TITLE: 'Su sesión se cerró porque ha expirado',
        SUBTITLE: 'EXPIRÓ LA SESIÓN',
        MESSAGE: 'Debes iniciar sesión de nuevo para ingresar a ReportingWare.',
    },
    register: {
        MESSAGE_REGISTER: 'Registro creado exitosamente',
        'AUTH-NO-REGISTER': 'Se presento un error al crear el registro',
        'AUTH-NO-REGISTER-CODE':
            'El código del usuario ya se encuentra registrado',
        'AUTH-NO-REGISTER-EMAIL':
            'El correo del usuario ya se encuentra registrado',
    },
};
